import React, { type FC, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";
import { useLocation } from "react-router-dom";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleFELinks: FC<{ onOpenSettings: (pk: GQL.IProductKey) => void }> = ({ onOpenSettings }) => {
    const { pathname = "" } = useLocation();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.freieErfassung,
                to: AppRoutes.freieErfassung,
                label: <FormattedMessage id="app.titles.FE" />,
            },
            {
                key: AppRoutes.freieErfassungTemplates,
                to: AppRoutes.freieErfassungTemplates,
                label: <FormattedMessage id="app.titles.templates" />,
            },
            {
                key: "settings",
                onClick: () => onOpenSettings(GQL.IProductKey.Fe),
                label: <FormattedMessage id="app.titles.settings" />,
            },
        ],
        [onOpenSettings],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
